type StringPropertyMap = {
    [key: string]: string;
};

type StringPropertyMaps = {
    [key: string]: StringPropertyMap;
};

const constants = {
    ACTIVE_FILTER_STATES_COUNTY: [
        'Blekinge',
        'Dalarna',
        'Gavleborg',
        'Gotland',
        'Halland',
        'Jamtland',
        'Jonkoping',
        'Kalmar',
        'Kronoberg',
        'Norrbotten',
        'Skane',
        'Sodermanland',
        'Stockholm',
        'Uppsala',
        'Varmland',
        'Vasterbotten',
        'Vasternorrland',
        'Vastmanland',
        'VastraGotaland',
        'Orebro',
        'Ostergotland',
    ],
    ACTIVE_FILTER_STATES_ITEM_CONDITION: ['New', 'Used'],
    ACTIVE_FILTER_STATES_ITEM_STATUS: ['Sold', 'Ended', 'Unsold'],
    ACTIVE_FILTER_STATES_ITEM_TYPE: ['Auction', 'FixedPrice'],
    ACTIVE_FILTER_STATES_SELLER_TYPE: ['Private', 'Company'],
    FILTER_STATES_ALLOWED_BUYER_REGIONS: {
        SWEDEN: 'sweden;eu;international',
        EU: 'eu;international',
        INTERNATIONAL: 'international',
        NORDIC: 'nordic;international',
    },
    MODALS: {
        FILTER_MODAL: 'filterModal',
        CATEGORY_MODAL: 'categoryModal',
    },
} as const;

export default constants;

export type PossibleFilterStates =
    | (typeof constants.ACTIVE_FILTER_STATES_ITEM_CONDITION)[number]
    | (typeof constants.ACTIVE_FILTER_STATES_SELLER_TYPE)[number]
    | (typeof constants.ACTIVE_FILTER_STATES_ITEM_STATUS)[number]
    | (typeof constants.ACTIVE_FILTER_STATES_ITEM_TYPE)[number];

export enum FilterNames {
    BRAND = 'brand',
    CLOTHES_SIZE = 'clothes_size',
    CLOTHES_SIZE_CHILDREN = 'clothes_size_children',
    SHOE_SIZE = 'shoe_size',
}

const { FILTER_STATES_ALLOWED_BUYER_REGIONS } = constants;

export const OPTIONS_TRANSLATION_KEYS: StringPropertyMaps = {
    queryScope: {
        AllWordsAnyOrder: 'searchParams_queryScope_allWordsAnyOrder',
        BestMatch: 'searchParams_queryScope_bestMatch',
        AnyWordsAnyOrder: 'searchParams_queryScope_anyWordsAnyOrder',
    },
    itemType: {
        All: 'searchParams_itemType_all',
        Auction: 'searchParams_itemType_auction',
        FixedPrice: 'searchParams_itemType_fixedPrice',
    },
    itemCondition: {
        All: 'searchParams_itemCondition_all',
        New: 'searchParams_itemCondition_new',
        Used: 'searchParams_itemCondition_used',
    },
    sellerType: {
        All: 'searchParams_sellerType_all',
        Private: 'searchParams_sellerType_private',
        Company: 'searchParams_sellerType_company',
    },
    itemStatus: {
        Active: 'searchParams_activeStatus_active',
        Sold: 'searchParams_activeStatus_sold',
        Unsold: 'searchParams_activeStatus_unsold',
    },
    sortBy: {
        Relevance: 'searchParams_sortOrder_relevance',
        TimeLeft: 'searchParams_sortOrder_timeLeft',
        AddedOn: 'searchParams_sortOrder_addedOn',
        HighestPrice: 'searchParams_sortOrder_highestPrice',
        LowestPrice: 'searchParams_sortOrder_lowestPrice',
        HighestPriceWithShipping:
            'searchParams_sortOrder_highestPriceWithShipping',
        LowestPriceWithShipping:
            'searchParams_sortOrder_lowestPriceWithShipping',
        MostBids: 'searchParams_sortOrder_highestNumberOfBids',
        LeastBids: 'searchParams_sortOrder_lowestNumberOfBids',
        HighestWishListCount: 'searchParams_sortOrder_highestWishListCount',
    },
    county: {
        HelaSverige: 'searchParams_searchCounty_sweden',
    },
    allowedBuyerRegions: {
        [FILTER_STATES_ALLOWED_BUYER_REGIONS.SWEDEN]:
            'searchParams_allowedBuyerRegion_sweden',
        [FILTER_STATES_ALLOWED_BUYER_REGIONS.EU]:
            'searchParams_allowedBuyerRegion_eu',
        [FILTER_STATES_ALLOWED_BUYER_REGIONS.INTERNATIONAL]:
            'searchParams_allowedBuyerRegion_international',
    },
};

export const OPTIONS_TRANSLATIONS: StringPropertyMaps = {
    county: {
        Blekinge: 'Blekinge',
        Dalarna: 'Dalarna',
        Gavleborg: 'Gävleborg',
        Gotland: 'Gotland',
        Halland: 'Halland',
        Jamtland: 'Jämtland',
        Jonkoping: 'Jönköping',
        Kalmar: 'Kalmar',
        Kronoberg: 'Kronoberg',
        Norrbotten: 'Norrbotten',
        Skane: 'Skåne',
        Sodermanland: 'Södermanland',
        Stockholm: 'Stockholm',
        Uppsala: 'Uppsala',
        Varmland: 'Värmland',
        Vasterbotten: 'Västerbotten',
        Vasternorrland: 'Västernorrland',
        Vastmanland: 'Västmanland',
        VastraGotaland: 'Västra Götaland',
        Orebro: 'Örebro',
        Ostergotland: 'Östergötland',
    },
};
